import {
	FETCH_PATIENT_ACTIVE_LIST_REQUEST,
	FETCH_PATIENT_ACTIVE_LIST_SUCCESS,
	FETCH_PATIENT_ACTIVE_LIST_FAILURE
} from "../../constants"

import { pharmacy_active_patient_list } from "../../../networking/urlEndPoints"

import Axios from "../../../networking/intraceptor"

export const activePatientsListRequest = () => ({
	type: FETCH_PATIENT_ACTIVE_LIST_REQUEST,
})

export const activePatientsListSuccess = (data) => ({
	type: FETCH_PATIENT_ACTIVE_LIST_SUCCESS,
	payload: data,
})

export const activePatientsListFailure = (error) => ({
	type: FETCH_PATIENT_ACTIVE_LIST_FAILURE,
	payload: error,
})

export const fetchAllActivePatientList = (search, abortController) => {
	return async (dispatch) => {
		dispatch(activePatientsListRequest())	
		let params = {}
		if (search) {
			params.search = search
		}
		try {
			const controller = abortController || new AbortController()
			const response = await Axios.get(`${pharmacy_active_patient_list}`, { params, signal: controller.signal })
			if (response?.status === 200) {
				dispatch(activePatientsListSuccess(response?.data))
			} else {
				throw new Error(response)
			}
		} catch (error) {
			// Ignore aborted/cancelled requests to prevent false error states.
			if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED") {
				return
			}
			const normalizedError = error?.response || {
				status: 0,
				message: error?.message || "Network request failed",
			}
			dispatch(activePatientsListFailure(normalizedError))
			throw error
		}
	}
}
